<template>
  <div class="teacher-gallery">
    <gallery-filter />
    <div class="container">
      <h1>{{ $store.state.study.title }}</h1>
    </div>
    <transition-group name="list" tag="div" class="teacher-gallery-grid">
      <gallery-item
        v-for="item in filteredGallery"
        :item="item"
        :key="item.id"
        @openslide="openSlideShowHandler"
        @addPaintover="getGallery"
        @deleted="getGallery()"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GalleryFilter from './Filter';
import GalleryItem from './GalleryItem';

export default {
  name: 'Gallery',
  components: { GalleryFilter, GalleryItem },
  mounted() {
    this.getStudy(this.$route.params.id);
    this.getGallery();
  },
  methods: {
    ...mapActions('study', ['getStudy', 'getGallery']),
    ...mapActions('teacher', ['setArtwork']),
    openSlideShowHandler(submission) {
      this.setArtwork(submission);
    },
  },
  computed: {
    ...mapGetters('teacher', ['filteredGallery', 'showingDelete']),
  },
};
</script>

<style lang="scss" scoped>
.teacher-gallery {
  width: 100%;
}

.item__actions {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
}

.item__download {
  padding: 0.5rem;
  background: color('background');
  color: color('primary');
  border-radius: 4px;
  margin-left: 0.75rem;
  display: inline-flex;

  &:active {
    background: color('primary');
    color: white;
  }
}

.teacher-gallery-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media screen and (min-width: 1280px) {
    grid-template-columns: repeat(6, 1fr);
  }

  @media screen and (min-width: 1921px) {
    grid-template-columns: repeat(10, 1fr);
  }

  &__item {
    position: relative;
    cursor: pointer;

    .author {
      position: absolute;
      padding: 0.5rem;
      bottom: 0;
      right: 0;
      color: white;
      background: rgba(0, 0, 0, 0.8);
    }

    img {
      vertical-align: bottom;
      max-width: 100%;
    }
  }
}
.list-enter-active,
.list-leave-active {
  transition: all 128ms;
}
.list-enter,
.list-leave-to {
  opacity: 0;
}
</style>
